/** Утилиты доступа к сохраненному профилю и активной компании пользователя. */

export const USER_DATA_STORAGE_KEY = "usersData";

const emptyUserData = () => ({
  initials: "",
  companies: [],
  current_company: null,
});

const clearLegacyUserDataCookie = () => {
  document.cookie = "usersData=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
};

/** Возвращает идентификатор активной компании пользователя. */
export function getCompanyId() {
  const userData = getUserData();
  return userData?.current_company?.id || null;
}

/** Возвращает идентификатор текущего пользователя. */
export function getUserId() {
  const userData = getUserData();
  return userData?.id || null;
}

/** Возвращает название активной компании пользователя. */
export function getCompanyName() {
  const userData = getUserData();
  return userData?.current_company?.name || "Компания";
}

/** Сохраняет профиль пользователя вне cookie, не ограничивая число компаний. */
export function saveUserData(userData) {
  try {
    localStorage.setItem(USER_DATA_STORAGE_KEY, JSON.stringify(userData));
    clearLegacyUserDataCookie();
  } catch (error) {
    console.error("Ошибка сохранения данных пользователя", error);
  }
}

/** Удаляет сохраненный профиль пользователя и устаревшую cookie. */
export function clearSavedUserData() {
  try {
    localStorage.removeItem(USER_DATA_STORAGE_KEY);
  } catch (error) {
    console.error("Ошибка удаления данных пользователя", error);
  }

  clearLegacyUserDataCookie();
}

/** Возвращает сохраненный профиль пользователя. */
export function getUserData() {
  let storedData;

  try {
    storedData = localStorage.getItem(USER_DATA_STORAGE_KEY);
  } catch (error) {
    console.error("Ошибка чтения данных пользователя", error);
    return emptyUserData();
  }

  if (!storedData) {
    return emptyUserData();
  }

  try {
    return JSON.parse(storedData);
  } catch (error) {
    console.error("Ошибка парсинга данных пользователя", error);
    return emptyUserData();
  }
}
